import React from 'react';
import {
  MarketingImage,
  MarketingImageType,
} from 'components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from 'components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import {
  HomeImageCaption,
  HomeSectionTitle,
  HomeIconedCaption,
} from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';
import { GrowIcon } from '../../icons/GrowIcon';

export function HomeGrow({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-grow.svg"
      textColumn={
        <>
          <HomeSectionTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'HomePage.HomeGrow.Title',
                '<strong>Advanced analytics and insights</strong> to help you understand and grow your audience.',
                'Anchor home page analytics features section title'
              ),
            }}
          />
          <MarketingBoldLink to="/features#analytics" onClick={onClickCTA}>
            {t(
              'HomePage.HomeGrow.AnalyticsFeaturesLinkText',
              'See all analytics features',
              'Anchor home page analytics features link text'
            )}
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <>
          <MarketingImage
            width={574}
            height={520}
            imagePath="home/grow"
            imageType={MarketingImageType.PNG}
            alt={t(
              'HomePage.HomeGrow.AnalyticsImageAlt',
              '{hostName} from the {podcastName} podcast on her laptop with headphones on',
              'Anchor home page analytics image screenreader information',
              {
                hostName: 'Athena Calderone',
                podcastName: 'More Than One Thing',
              }
            )}
          />
          <HomeIconedCaption>
            <GrowIcon />
            <HomeImageCaption
              dangerouslySetInnerHTML={{
                __html: t(
                  'HomePage.HomeGrow.AnalyticsImageCaption',
                  '<strong>“{podcastName}”</strong> has 25k unique listeners with 2M+ all-time plays.',
                  'Anchor home page analytics image caption',
                  { podcastName: 'More Than One Thing' }
                ),
              }}
            />
          </HomeIconedCaption>
        </>
      }
    />
  );
}
